import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page container" style={{backgroundColor: "black",
    textAlign: "center",color: "white"}}>
      <hr className="my-5"></hr>
      <h1>Error 404!</h1>
      <p>Page Not Found!</p>
      <p>
        <i style={{color:'white'}}>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}